import React, { useContext, useState } from 'react';
import ModalButton from './ModalButton';
import { AppContext } from '../App';
import useRemote from '../hooks/useRemote';
import { format, parseISO } from 'date-fns';

const UpgradeModal = ({onDone, closeModal})=>{
	
	const app = useContext(AppContext);
	const remote = useRemote();

	const [ count, setCount ] = useState(100);
	const [ terms, setTerms ] = useState(3);
	const [ type, setType ] = useState("TERM");
	const [ to, setTo ] = useState("CONTACT");

	const act = ()=>{
		let expiry = null;
		if (type === "TERM") {
			switch (terms) {
				case 1: expiry = "2025-06-28"; break;
				case 2: expiry = "2025-09-20"; break;
				case 3: expiry = "2025-12-31"; break;
				case 4: expiry = "2026-04-12"; break;
				case 5: expiry = "2026-07-04"; break;
				case 6: expiry = "2026-09-26"; break;
				case 7: expiry = "2026-12-31"; break;
			}
		}
		const data = {
			requestedBy: app.user,
			type,
			expiry,
			count: type === "TERM" ? terms : count,
			mailTo: to === "CONTACT" ? app.school.contact : app.user
		};

		remote.requestInvoice(data).then(remote.refreshSchool).then(onDone);
	}

	return <div>
		<div><strong>{app.school.name}</strong>'s {app.school.mathsLicense.toLowerCase()} licence will expire on {app.school.mathsLicenseExpiry ? format(parseISO(app.school.mathsLicenseExpiry), 'dd MMM yyyy') : "soon"}.  To continue using 
		Jumbletree LEARN after this date you will need to upgrade to a paid licence.  Please note that payments may take up to two working days to process.</div>
		<div>Select your plan below</div>
		<div onClick={()=>setType("TERM")} className="upgrade-option"><input type="radio" checked={type === "TERM"} /> Unlimited use at $10+GST/per term billed until end of <select value={terms} onChange={e=>setTerms(e.target.value)}>
			<option value="1">Term 4, 2025</option>
			<option value="2">Term 1, 2026</option>
			<option value="3">Term 2, 2026</option>
			<option value="4">Term 3, 2026</option>
			<option value="5">Term 4, 2026</option>
			<option value="9">Term 4, 2027</option>
		</select> totalling ${(terms * 10).toFixed(2)}</div>
		<div onClick={()=>setType("PAGE")} className="upgrade-option"><input type="radio" checked={type === "PAGE"} /> Pay for 
			<input value={count} onChange={e=>setCount(e.target.value.replace(/[^\d]/, ""))} style={{width: 30}} />
			pages at $0.02+GST/page, totalling ${(count * 0.02).toFixed(2)}
		</div>
		<div>Send the invoice</div>
		<div className="upgrade-option"><input type="radio" checked={to === "CONTACT"} onClick={()=>setTo("CONTACT")} />To {app.school.contact}</div>
		<div className="upgrade-option"><input type="radio" checked={to === "ME"} onClick={()=>setTo("ME")} />To me &lt;{app.user}&gt;</div>
		<ModalButton text="Send invoice" onClick={act} showBail={true} bail={closeModal} />
	</div>
}

export default UpgradeModal;